// extracted by mini-css-extract-plugin
export default {"root":"VoteStuList_root__WONxi","search":"VoteStuList_search__kdbWq"};